module.exports = __webpack_public_path__ + "full_reward_icon.webp";